// extracted by mini-css-extract-plugin
export var blogHeader = "blog-module--blogHeader--de151";
export var blogPostContainer = "blog-module--blogPostContainer--f3728";
export var blogPostList = "blog-module--blogPostList--6e2c4";
export var blogPostListContainer = "blog-module--blogPostListContainer--8efe8";
export var postContentBlock = "blog-module--postContentBlock--044ea";